import Vue from "vue";
import axios from "axios";

const BASE_URL = "https://xiaoe.xingtongtech.cn/api";//线上 
// const BASE_URL = "http://192.168.0.66:9004";//公司内网
// const BASE_URL = "http://192.168.0.94:80";//个人
// const BASE_NAME = "/wsh";
const BASE_NAME = "";
const API = {
  /*
    服务号接口
  */ 
  //分页查询已绑定列表
  getBindPage:`${BASE_NAME}/userBwx/page`,
  //绑定学生账号
  bindStudents:`${BASE_NAME}/userBwx/add`,
  //解绑账号
  unboundStudents:`${BASE_NAME}/userBwx/unbinding`,
  //查询账号
  getUserByPhone:`${BASE_NAME}/user/getUserByPhone`,

  /*
    学习情况
  */ 
  getDay:`${BASE_NAME}/wxPush/getlearnData`, //日报基本数据
  getDayDetail:`${BASE_NAME}/blade-english/report/v2/learnDailyDetail`, //日报详情
  getDayReport:`${BASE_NAME}/blade-english/report/v2/learnSummaryReport`, //日周月报总结

};
const config = {
  API,
  BASE_URL
};

// 添加请求拦截器
const service = axios.create({
  baseURL: config.BASE_URL,
  timeout: 30000
});
service.interceptors.request.use(
  config => {
    // 设置请求头信息
    // config.headers.Authorization = "Bearer " +  sessionStorage.getItem("token") || "";
    // config.headers['Content-Type'] = 'text/plain' // 请求头类型
    

    // if (config.method === "post") {
    //   config.data = Qs.stringify(config.data);
    // }
    return config;
  },
  error => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
// service.interceptors.response.use(
//   response => {
//     // 保存响应头返回的token
//     console.log("a", response);
//     if (response.data.data && response.data.data.token) {
//       sessionStorage.setItem("token", response.data.data.token);
//     }
//     return response;
//   },
//   error => {
//     // 对响应错误做统一处理
//     console.log("response error", error);
//     // 如果登录过期就重新登录
//     if (error.message === "Request failed with status code 401") {
//       Notification.warning({
//         message: "登录超时，请重新登录"
//       });
//       sessionStorage.clear();
//       router.replace("/login");
//     }else{
//       Notification.warning({
//         message: "网络错误"
//       });
//       router.replace("/login");
//     }
//     return Promise.reject(error);
//   }
// );

export default {
  service,
  BASE_URL,
  API
};



// WEBPACK FOOTER //
// ./src/http/index.js